import { PortalComponent } from '@modules/portal/portal.component';
import { Routes } from '@angular/router';
import { PORTAL_ROUTE_NAMES } from './portal.routes.names';
import { AuthGuard } from '@app/core/guards/auth-guard/auth.guard';
import { RedirectGuard } from '@app/core/guards/redirectGuard/redirectGuard';

export const PORTAL_ROUTES: Routes = [
  {
    path: '',
    component: PortalComponent,
    canActivate: [AuthGuard],
    data: {
      depth: 2,
      breadcrumb: 'Home',
    },
    children: [
      {
        path: PORTAL_ROUTE_NAMES.DASHBOARD,
        loadChildren: '@modules/portal/pages/dashboard/dashboard.module#DashboardModule',
        data: {
          depth: 1,
          breadcrumb: 'Home',
        },
      },
      {
        path: PORTAL_ROUTE_NAMES.PROFILE,
        loadChildren: '@modules/portal/pages/profile/profile.module#ProfileModule',
        data: {
          breadcrumb: 'Editar o perfil',
          depth: 2,
        },
      },
      {
        path: PORTAL_ROUTE_NAMES.PASSWORD,
        loadChildren: '@modules/portal/pages/password/password.module#PasswordModule',
        data: {
          breadcrumb: 'Alterar Senha',
          depth: 2,
        },
      },
      {
        path: PORTAL_ROUTE_NAMES.MY_CONTRACTS,
        loadChildren: '@modules/portal/pages/contracts/contracts.module#ContractsModule',
        data: {
          breadcrumb: 'Meus Contratos',
          depth: 2,
        },
      },
      {
        path: PORTAL_ROUTE_NAMES.MY_EXTRACTS,
        loadChildren: '@modules/portal/pages/extracts/extracts.module#ExtractsModule',
        data: {
          breadcrumb: 'Meus Extratos',
          depth: 2,
        },
      },
      {
        path: PORTAL_ROUTE_NAMES.REPORT_ACCIDENTS,
        loadChildren:
          '@modules/portal/pages/report-accidents/report-accidents.module#ReportAccidentsModule',
        data: {
          breadcrumb: 'Comunicação de Sinistro',
          depth: 2,
        },
      },
      {
        path: PORTAL_ROUTE_NAMES.FREQUENTLY_ASKED_QUESTIONS,
        loadChildren:
          '@modules/portal/pages/frequently-asked-questions/frequently-asked-questions.module#FrequentlyAskedQuestionsModule',
        data: {
          breadcrumb: 'Perguntas Frequentes',
          depth: 2,
        },
      },
      {
        path: PORTAL_ROUTE_NAMES.CONTACT_US,
        loadChildren:
          '@modules/portal/pages/contact-us/contact-us.module#ContactUsModule',
        data: {
          breadcrumb: 'Fale conosco',
          depth: 2,
        },
      },
      // {
      //   path: PORTAL_ROUTE_NAMES.REPORTS_PORTAL,
      //   loadChildren:
      //     '@modules/portal/pages/reports-portal/reports-portal.module#ReportsPortalModule',
      //   data: {
      //     breadcrumb: 'Portal de Denúncias',
      //     depth: 2,
      //   },
      // },
      {
        path: PORTAL_ROUTE_NAMES.REPORTS_PORTAL,
        canActivate: [RedirectGuard],
        component: RedirectGuard,
        data: {
          externalUrl: 'https://sabemi.becompliance.com/canal-etica/canal-denuncias?origin=$2y$10$.ft8lL.H2/FSAX.IqUl3POjiLPMpwXZPRxFQfPdtxZnfvNwl5uvFa',
        },
      },
      {
        path: PORTAL_ROUTE_NAMES.TRACK_REQUESTS,
        loadChildren:
          '@modules/portal/pages/track-requests/track-requests.module#TrackRequestsModule',
        data: {
          breadcrumb: 'Acompanhar solicitações',
          depth: 2,
        },
      },
      {
        path: PORTAL_ROUTE_NAMES.REGULATIONS,
        loadChildren:
          '@modules/portal/pages/regulations/regulations.module#RegulationsModule',
        data: {
          breadcrumb: 'Regulamentos',
          depth: 2,
        },
      },
    ],
  },
];
